module.exports = __webpack_public_path__ + "static/media/galerija_2022_0008.e46bd6e6.jpg";